<div class="kt-subheader kt-grid__item" [ngClass]="{'kt-container--clear': clear}" id="kt_subheader">
    <div class="kt-container" [ngClass]="{'kt-container--fluid': fluid}">
        
    </div>
</div>

<!-- <subheader1 *ngIf="!layout || layout === 'subheader-v1'" [fluid]="fluid" [clear]="clear"></subheader1>
<subheader2 *ngIf="layout === 'subheader-v2'" [fluid]="fluid" [clear]="clear"></subheader2>
<subheader3 *ngIf="layout === 'subheader-v3'" [fluid]="fluid" [clear]="clear"></subheader3> -->